import { css } from '@emotion/css';
import { theme } from 'antd';
import { useMemo } from 'react';

export const useBefundDetailsStyles = (isSelected: boolean) => {
  const { token } = theme.useToken();

  return useMemo(
    () => ({
      layout: css`
        height: 100%;
        min-width: 300px;
        padding-left: ${token.paddingXL}px;
        flex-grow: 1;
        display: flex;
        flex-direction: column;

        @media (max-width: ${token.screenLG}px) {
          height: calc(100dvh - 80px);
          position: absolute;
          left: 0;
          right: 0;
          padding: 0 ${token.paddingLG}px 0 ${token.paddingLG}px;
          transform: translateX(${isSelected ? 0 : '100vw'});
          transition: transform 0.4s ease-in-out;

          background-color: ${token.Layout?.bodyBg};
          z-index: 10;
        }
      `,
    }),
    [isSelected, token]
  );
};
